import { render, staticRenderFns } from "./partnersEquity.vue?vue&type=template&id=09a36c87&scoped=true&"
import script from "./partnersEquity.vue?vue&type=script&lang=js&"
export * from "./partnersEquity.vue?vue&type=script&lang=js&"
import style0 from "./partnersEquity.vue?vue&type=style&index=0&id=09a36c87&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a36c87",
  null
  
)

export default component.exports